import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FDConfirmationDialog,
  FDSecondaryActionButton,
} from '@facet-wealth/design';
import { useSnackbarContext } from 'Context/SnackbarContext';


export const UnlinkInstitutionButton = ({ onDeleteSuccess, resource }) => {
  const { displayErrorMessage } = useSnackbarContext();
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const name = resource.attr('institution');

  const handleUnlink = async () => {
    setLoading(true);
    try {
      await resource.delete();
      setLoading(false);
      onDeleteSuccess();
    } catch (err) {
      setLoading(false);
      displayErrorMessage(err.message || `Unable to unlink ${name}`);
    }
  };

  return (
    <>
      <FDSecondaryActionButton label={'Unlink'} icon={'delete'} onClick={() => setShowConfirm(true)} size={'sm'} />
      <FDConfirmationDialog
        title={'Are you sure?'}
        message={`You will need to re-link ${name || 'this institution'} to get back all of the account data associated with this financial institution`}
        cancelLabel={'Cancel'}
        confirmLabel={'Confirm'}
        confirmButtonType="error"
        onConfirm={handleUnlink}
        onCancel={() => setShowConfirm(false)}
        onClose={() => setShowConfirm(false)}
        showCloseIcon={false}
        loading={loading}
        open={showConfirm}
      />
    </>
  );
};

UnlinkInstitutionButton.defaultProps = {
};

UnlinkInstitutionButton.propTypes = {
  resource: PropTypes.object.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
};
